export const LOCAL_FEATURE_FLAGS = {
	DIGITAL_MENU_CONFIG: true,
	OPERATION_MODE_VITRINE: true,
	OPERATION_MODE_POS_PAGO: true,
	OPERATION_MODE_PRE_PAGO: true,
} as const;
